import {
  ListItem,
  ListItemAvatar,
  ListItemButton,
  ListItemButtonProps,
  ListItemProps,
  ListItemText,
  Typography,
} from '@mui/material';
import { AccountIcon, AvatarBadge, AvatarCurrency, AvatarIcon, Money } from '../..';
import { UiAccount } from '../../types';

export function AccountListItemContent({
  account,
  withBadge,
}: {
  account: UiAccount;
  withBadge?: boolean;
}) {
  return (
    <>
      <ListItemAvatar>
        {withBadge ? (
          <AvatarBadge type="currency" currency={account.balance.currency}>
            <AvatarIcon icon={<AccountIcon />} />
          </AvatarBadge>
        ) : (
          <AvatarCurrency currency={account.balance.currency} />
        )}
      </ListItemAvatar>
      <ListItemText
        primary={<Money variant="body1" value={account.balance} />}
        secondary={
          <Typography
            variant="caption"
            sx={{
              color: 'text.secondary',
            }}
          >
            {account.name}
          </Typography>
        }
        disableTypography
      />
    </>
  );
}

export type AccountListItemProps = ListItemProps<'li', { account: UiAccount; withBadge?: boolean }>;

export function AccountListItem({ account, withBadge, ...props }: AccountListItemProps) {
  return (
    <ListItem {...props}>
      <AccountListItemContent account={account} withBadge={withBadge} />
    </ListItem>
  );
}

export type AccountListItemButtonProps<RootComponent extends React.ElementType = 'div'> =
  ListItemButtonProps<RootComponent, { account: UiAccount; withBadge?: boolean }>;

export function AccountListItemButton<RootComponent extends React.ElementType = 'div'>({
  account,
  withBadge,
  ...props
}: AccountListItemButtonProps<RootComponent>) {
  return (
    <ListItemButton {...props}>
      <AccountListItemContent account={account} withBadge={withBadge} />
    </ListItemButton>
  );
}
